import { getGtmTagValue, gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
const gtmCompareTrimsBap = ({ dealerName, compareLink, gtmComponentName, trim, gtmTrimName, availabilityFlag, }) => {
    var _a, _b, _c, _d;
    const gtmPayload = {
        event: 'bap_trim_cta',
        dealer_name: getGtmTagValue(dealerName),
        cta_type: 'compare trims',
        cta_placement: 'select trim',
        link_text: 'compare trims',
        link_url: compareLink,
        component_type: gtmComponentName,
        model: getGtmTagValue(trim === null || trim === void 0 ? void 0 : trim.modelName),
        trim: removeAllTagsFromMarkdown(gtmTrimName),
        body_style: getGtmTagValue((_d = (_c = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.replace(/<[^>]*>/g, ' ')) === null || _d === void 0 ? void 0 : _d.trim()),
        availability_flag: availabilityFlag,
    };
    const filteredPayload = Object.entries(gtmPayload).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});
    gtmEvent(filteredPayload);
};
export default gtmCompareTrimsBap;
